// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo_Logo__fU-Qy","FastRiver":"Logo_FastRiver__2BrDq","PartnerLogo":"Logo_PartnerLogo__GLk2q","Img":"Logo_Img__3XKVw"};